<template>
    <form @submit.prevent="submitForm" id='Scan' class="row">

    <div class="mb-3 col-12">
        <div class="row mb-3">
            <div class="col-12">
                <label for="scanned-skus" class="form-label">
                    Scan Waybill or Select Buy
                </label>
                <ul class="list-group">
                    <li :class="selectedSkus.includes(sku) ? 'list-group-item active' : 'list-group-item'" v-for="(sku, index) in scannedSkus">
                        <div class="row">
                            <div class="col-8" @click="selectSku(sku)">
                            {{ sku }}
                            </div>
                            <div class="col-4 text-right">
                            <button type="button" class="btn btn-default btn-sm">
                                View More
                            </button>
                            </div>
                        </div>
                    </li>
                    <li class="list-group-item" v-if="scannedSkus.length == 0">
                        Nothing scanned yet
                    </li>
            </ul>
            </div>
        </div>
    

        <div class="row mb-3">
            <div class="col-6">
                <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="clearSelected" :disabled="!scannedSkus.length">
                Clear
                </button>
            </div>
            <div class="col-6 text-right">
                <button type="button" class="btn btn-primary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
                Enter
                </button>
            </div>
        </div>

        <div class='row divider'>
            <div class='col-12'>
                <h3>Waybills in Current Session</h3>
            </div>
        </div>
        <div class="card">
        <!--<div class="card-header">
            Item Location
        </div> -->
        <div class="card-body">
            <table class="table">
            <tbody>
                <tr v-for="(sku, index) in scannedSkus">
                <td>
                    {{ sku }}
                </td>
                <td>
                    TODO: OLD BIN
                </td>
                <td>
                    TODO: NEW BIN
                </td>
                </tr>
            </tbody>
            </table>
        </div>
        </div>
        <div class="row mb-3">
        <div class="col-6">
            <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="clearSelected" :disabled="!scannedSkus.length">
            Clear Selected
            </button>
        </div>
        <div class="col-6 text-right">
            <button type="button" class="btn btn-primary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
            Clear All
            </button>
        </div>
        </div>
        <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
        <button type="submit" class="btn btn-success w-100 btn-finalize-receipt">
            Save
        </button>
        </div>
        <div class='row divider'>
            <div class='col-12'>
                <h3>Waybills with No Match</h3>
            </div>
        </div>
        <div class="card">
        <!--<div class="card-header">
            Item Location
        </div> -->
            <div class="card-body">
                <table class="table">
                <tbody>
                    <tr v-for="(sku, index) in scannedSkus">
                    <td>
                        {{ sku }}
                    </td>
                    <td>
                        TODO: OLD BIN
                    </td>
                    <td>
                        TODO: NEW BIN
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
        <div class="mb-5 row">
            <div class="col-10 col-sm-7 offset-2 offset-sm-5">
                <button type="button" class="btn btn-primary btn-sm btn-set-target-bin">
                Share Unmatched Waybills
                </button>
            </div>
        </div>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'Scan',
    data() {
      return {
        sku : '',
        selectedSkus : [],
        scannedSkus : [],
      }
    },
    mounted() {
      console.log('csrf', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))

    },
    methods: {
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
      },
      selectSku(sku) {
        if ( this.selectedSkus.includes(sku) ) {
          this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
        } else {
          this.selectedSkus.push(sku)
        }
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
      },
      addSku(sku) {
        if ( sku ) {
          if ( this.scannedSkus.indexOf(sku) == -1 ) { //TODO: not working
            this.scannedSkus.push(sku)
          }
        }
      },
      validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          this.addSku(this.sku)
          this.sku = ''
        }
      },
      submitForm() {
        const {
          sku,
          scannedSkus
        } = this

        this.$api.post('/api/power-scan/transfer-items-to-bin-location', {
          //_token : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          sku,
          scannedSkus
        }).then((response) => {
          console.log('Roman:', response)
        })

      }
    }
  }
</script>